<nz-table class="expand-table"
  #expandableTable
  [nzData]="rows"
  nzTableLayout="fixed"
  [nzShowPagination]="showPagination"
  [(nzPageIndex)]="pageIndex"
  [(nzPageSize)]="pageSize"
  [nzShowSizeChanger]="true">
  <thead>
    <tr>
      @for (column of visibleColumns; track column.mapping_key) {
        <th scope="col" [ngStyle]="column.headerStyles" 
            [class.checkbox-header]="column.mapping_key === '_checkbox'"
            [ngClass]="{'selected-column-header': column.isSelected === true}">
            @if (column.mapping_key === '_checkbox') {
              <input type="checkbox" 
                     [ngModel]="checked" 
                     [indeterminate]="indeterminate" 
                     (ngModelChange)="onAllChecked($event)"
                     [checked]="checked" />
            } @else {
              {{ column.display_name }}
            }
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (data of expandableTable.data; track data._uuid) {
      <tr [ngClass]="{'selected-row': data.isSelected === true}">
        @for (column of visibleColumns; track column.mapping_key) {
          <td [nzShowExpand]="column.isExpandable"
              [nzExpand]="expandSet.has(data._uuid)"
              (nzExpandChange)="onExpandChange(data._uuid, $event)" 
              [class.checkbox-cell]="column.mapping_key === '_checkbox'"
              [ngClass]="{'selected-column': column.isSelected === true}">
            @if (column.mapping_key === '_checkbox') {
              <input type="checkbox" 
                     [ngModel]="setOfCheckedId.has(data._uuid)" 
                     (ngModelChange)="onItemChecked(data._uuid, $event)"
                     [checked]="setOfCheckedId.has(data._uuid)" />
            } @else {
              @if (column.mapping_key === 'rciScore') {
                <app-star-ranker [rank]="data[column.mapping_key]" [isError]="data[column.mapping_key] <= 2"></app-star-ranker>
              } @else {
                <ng-container *ngIf="isStringList(data[column.mapping_key]); else plainText">
                  <ol>
                    <li *ngFor="let item of splitStringList(data[column.mapping_key])">{{ item }}</li>
                  </ol>
                </ng-container>
                <ng-template #plainText>{{ data[column.mapping_key] }}</ng-template>
              }
            }
          </td>
        }
      </tr>
      @if (expandSet.has(data._uuid)) {
      <tr [nzExpand]="true">
        <td [attr.colspan]="visibleColumns.length">
          <div class="expanded-content">
            <ng-container *ngFor="let key of allColumnKeys">
              <ng-container *ngIf="key !== 'path'">
                <div class="detail-row" [ngSwitch]="key">
                <span class="detail-title">{{ getSectionTitle(key) }}</span>
                <div class="detail-value">
                  <div *ngSwitchCase="'status'" class="status-tag" [ngClass]="{
                    'incomplete': data[key] === 'Incomplete',
                    'complete': data[key] === 'Complete',
                    'inprogress': data[key] === 'In Progress',
                    'todo': data[key] === 'To Do'
                  }">
                    {{ data[key] }}
                  </div>
                  <div *ngSwitchCase="'rciScore'">
                    <app-star-ranker [rank]="data[key]" [isError]="data[key] <= 2"></app-star-ranker>
                  </div>
                  
                  <ng-container *ngSwitchCase="'qualityReportId'">
                    <div class="d-flex flex-row align-items-center justify-content-flex-start" *ngIf="data[key]">
                      <span>
                        {{data[key]}}
                      </span>
                      <img
                        src="assets/images/virtusa-icons/card-expand-icon.svg" class="expand-img mx-2"
                        alt="download" (click)="openReport(data)" (keydown.enter)="openReport(data)"
                      />
                    </div>
                  </ng-container>
                  
                  <ng-container *ngSwitchCase="'expectedResults'">
                    <ng-container *ngIf="isArray(data[key])">
                      <ul class="no-bullet-list">
                        <li *ngFor="let point of data[key]">{{ point }}</li>
                      </ul>
                    </ng-container>
                    <ng-container *ngIf="isStringList(data[key])">
                      <ul class="no-bullet-list">
                        <li *ngFor="let point of splitStringList(data[key])">{{ point }}</li>
                      </ul>
                    </ng-container>
                    <ng-container *ngIf="!isArray(data[key]) && !isStringList(data[key])">
                      <p class="header-13-1">{{ data[key] }}</p>
                    </ng-container>
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                    <ng-container *ngIf="isArray(data[key])">
                      <ol [class.bold-value]="visibleColumnKeys.has(key)">
                        <li *ngFor="let point of data[key]">{{ point }}</li>
                      </ol>
                    </ng-container>
                    <ng-container *ngIf="isStringList(data[key])">
                      <ol [class.bold-value]="visibleColumnKeys.has(key)">
                        <li *ngFor="let point of splitStringList(data[key])">{{ point }}</li>
                      </ol>
                    </ng-container>
                    <ng-container *ngIf="!isArray(data[key]) && !isStringList(data[key])">
                      <p class="header-13-1" [class.bold-value]="visibleColumnKeys.has(key)">{{ data[key] }}</p>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
              </ng-container>
            </ng-container>
          </div>
        </td>
      }
    }
  </tbody>
</nz-table>